// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const elekid: PokeData = {
  "id": 239,
  "name": "elekid",
  "height": 6,
  "weight": 235,
  "base_experience": 72,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "leer",
    "low-kick",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "screech",
    "light-screen",
    "swift",
    "spark",
    "charge",
    "shock-wave",
    "discharge",
    "electro-ball"
  ],
  "moves": [
    "thunder-punch",
    "leer",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "zap-cannon",
    "thunder-fang",
    "electric-terrain",
    "electric-wrath",
    "volt-crash",
    "wild-charge",
    "volt-switch"
  ],
  "evolution_chain": {
    "id": 60,
    "item": null,
    "species": [
      {
        "name": "elekid",
        "order": 145,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "electabuzz",
        "order": 146,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 239,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "electivire",
        "order": 147,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 125,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45.5,
    "speed": 95,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
